<template>
  <div class="learningList">
    <div class="classification">
      <li v-for="(item, index) in classifications"
          @click="classification(index,item.type)"
          :class="index === classificationIndex ? 'choice':'' " :key="index">
        {{item.name}}
      </li>
    </div>
    <div class="list">
      <div class="courseList">
        <div class="indexCourse">
          <ul class="publick">
            <li v-for="(item, index) in info.data" :key="index">
              <router-link :to="{ path: '/CourseDetails', query: { id: item.id }  }">
                <div class="img">
                  <img :src="item.cover" width="287" height="175" alt="">
                  <div v-if="item.tag"  class="hot">{{item.tag}}</div>
<!--                  <div class="label">-->
<!--                    <span v-for="(items, indexs) in item.course_task" :key="indexs">{{items.name}}</span>-->
<!--                  </div>-->
                </div>
                <div class="describe line-clamp-2">{{item.title}}</div>
                <div class="dykc">{{item.ffjz_course}}</div>
                <div class="dykc">{{item.period_title}}</div>
                <div class="num">
                  <div class="people fl"><img src="./people.png" width="18" height="12" alt="">{{item.study_num}}</div>
                  <div class="comment fl"><img src="./comment.png" width="14" height="13" alt="">{{item.log_num}}</div>
                </div>
              </router-link>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <div class="page publick">
      <el-pagination
        background
        layout="prev, pager, next"
        @current-change="pageChange"
        :total="info.count">
      </el-pagination>
    </div>
  </div>
</template>

<script>

  export default {
    data () {
      return {
        classifications: [
          {
            type: 1,
            name: '未开始'
          },
          {
            type: 2,
            name: '已结束'
          },
          {
            type: 3,
            name: '直播中'
          }
        ],
        classificationIndex: 0,
        page: 1,
        type: 1,
        info: {}
      }
    },
    created () {
      this.getData()
    },
    methods: {
      pageChange (page) {
        this.page = page
        this.getData()
      },
      classification (index, type) {
        this.classificationIndex = index
        this.type = type
        this.page = 1
        this.getData()
      },
      getData () {
        this.$http.post('/apipx/Teacher/myreserve', {
          p: this.page,
          row: 10,
          type: this.type,
          token: JSON.parse(localStorage.getItem('login')).token
        }).then(res => {
          if (res.code === 0) {
            this.info = res
          }
        })
      }
    }
  }
</script>

<style type="text/scss" lang="scss">
  .learningList {
    .classification {
      width: 1200px;
      margin: 45px auto;
      overflow: hidden;

      li {
        float: left;
        width: 75px;
        background-color: #fff;
        border-radius: 20px;
        text-align: center;
        height: 35px;
        line-height: 35px;
        cursor: pointer;
        margin: 0 10px;

        &:first-child {
          margin: 0;
        }

        &:hover {
          background-color: #ff8484;
          color: #fff;
        }

        &.choice {
          background-color: #ff8484;
          color: #fff;
        }
      }
    }

    .list {
      margin-top: -55px;

      .courseList {
        .indexCourse {
          width: 100%;
          overflow: hidden;
          box-shadow: 0px 20px 20px -20px #f5f5f5;
          padding-bottom: 80px;
          margin-bottom: 50px;

          li {
            width: 287px;
            overflow: hidden;
            float: left;
            margin: 50px 17.3px 0 0;
            cursor: pointer;

            &:nth-child(4n) {
              margin-right: 0;
            }

            .img {
              width: 287px;
              height: 175px;
              border-radius: 5px;
              overflow: hidden;
              position: relative;

              .hot {
                position: absolute;
                width: 50px;
                height: 35px;
                border-radius: 0 17.5px 17.5px 0;
                background-color: #fff;
                text-align: center;
                line-height: 35px;
                color: #fc8375;
                font-size: 14px;
                font-weight: bold;
                left: 0;
                top: 20px;
              }

              .label {
                width: 100%;
                position: absolute;
                left: 0;
                bottom: 20px;

                span {
                  background-color: rgba(0, 0, 0, 0.5);
                  color: #fff;
                  padding: 5px 8px;
                  border-radius: 10px;
                  margin: 0 0 0 10px;
                }
              }
            }

            .dykc {
              margin: 10px auto;
              color: #8f8f8f;
            }

            .describe {
              width: 287px;
              height: 20px;
              line-height: 20px;
              margin-top: 15px;
            }

            .num {
              height: 20px;
              width: 100%;
              font-size: 12px;
              color: #8f8f8f;
              margin-top: 10px;

              img {
                display: block;
                float: left;
              }

              .people {
                line-height: 20px;
                margin-right: 20px;

                img {
                  margin: 3px 5px 0 0;
                }
              }

              .comment {
                line-height: 20px;

                img {
                  margin: 5px 5px 0 0;
                }
              }
            }
          }
        }
      }
    }

    .page {
      height: 35px;
      margin: 50px auto;

      .el-pagination {
        width: 500px;
        margin: 0 auto;
      }

      .el-pagination.is-background .btn-next, .el-pagination.is-background .btn-prev, .el-pagination.is-background .el-pager li {
        border-radius: 50%;
        min-width: 33px;
        min-height: 33px;
        line-height: 33px;
        margin: 0 8px;

        &:hover {
          color: #ff8484;
        }
      }

      .el-pagination.is-background .el-pager li:not(.disabled).active {
        background-color: #ff8484;
        color: #FFF;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/learning/live/live.vue